module.exports = __webpack_public_path__ + "media/logos/tissue-logo-1f4ef680.svg";